// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import "./channels"
import * as ActiveStorage from "@rails/activestorage"
ActiveStorage.start()

// Trix Editor
import "trix"

// Disable file attachments in Trix (images, files)
document.addEventListener("trix-file-accept", (e) => {
  e.preventDefault()
})
